import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const fastpassColors = {
  primary50: '#F2F2F2',
  primary100: '#D6D6D6',
  primary200: '#ADADAD',
  primary300: '#858585',
  primary400: '#5C5C5C',
  primary500: '#333333',
  primary600: '#000000',
  primary700: '#000000',
  primary800: '#000000',
  primary900: '#000000',

  secondary50: '#2F3640',
  secondary100: '#424A57',
  secondary200: '#525D6D',
  secondary300: '#637184',
  secondary400: '#718096',
  secondary500: '#A0AEC0',
  secondary600: '#CBD5E0',
  secondary700: '#E2E8F0',
  secondary800: '#EDF2F7',
  secondary900: '#F7FAFC',
}

export const colorTheme = stylex.createTheme(colors, fastpassColors)
